import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Login Redux States
import { FORGET_PASSWORD, OTP_FORGET_PASSWORD, STAFF_FORGET_PASSWORD, STAFF_OTP_FORGET_PASSWORD } from "./actionTypes";
import {
  userForgetPasswordSuccess,
  userForgetPasswordError,
  userForgetPasswordErrorWithOTP,
  userForgetPasswordSuccessWithOTP,
  staffForgetPasswordError,
  staffForgetPasswordSuccess,
  staffForgetPasswordErrorWithOTP,
  staffForgetPasswordSuccessWithOTP,
} from "./actions";
import { postFakeForgetPwd, postFakeForgetPwdwithOtp, postJwtForgetPwd, postForgetPwdStaff, postForgetPwdStaffOtp } from "../../../helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

function* forgetUser({ payload: { user, onSuccess, onError } }) {
  try {
    const response = yield call(postFakeForgetPwd, user);
    yield call(responseHandler, "Forget Password", response, userForgetPasswordSuccess, userForgetPasswordError, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(userForgetPasswordError(error));
    showToast("error", "Forget Password", error);
  }
}
function* forgetStaff({ payload: { user, history } }) {
  try {
    const response = yield call(postForgetPwdStaff, user);
    if (response) {
      yield put(staffForgetPasswordSuccess("Password sent, please check your mailbox..."));
      history.push("/forgot-password-reset-staff");
    }
  } catch (error) {
    yield put(staffForgetPasswordError(error));
    showToast("error", "Forget Password", error);
  }
}
function* forgetUserWithOtp({ payload: { user, onSuccess, onError, headers } }) {
  try {
    const response = yield call(postFakeForgetPwdwithOtp, user, headers);
    yield call(responseHandler, "Forget Password", response, userForgetPasswordSuccessWithOTP, userForgetPasswordErrorWithOTP, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(userForgetPasswordErrorWithOTP(error));
    showToast("error", "Forget Password", error);
  }
}
function* forgetStaffWithOtp({ payload: { user, history } }) {
  try {
    const response = yield call(postForgetPwdStaffOtp, user);
    if (response) {
      if (response.status) {
        yield put(staffForgetPasswordSuccessWithOTP(response.message));
        showToast("success", "Forget Password", response.message);
        history.push("/login");
      } else {
        yield put(staffForgetPasswordErrorWithOTP(response.message));
        showToast("error", "Forget Password", response.message);
      }
    }
  } catch (error) {
    yield put(staffForgetPasswordErrorWithOTP(error));
  }
}

export function* watchUserPasswordForget() {
  yield takeEvery(FORGET_PASSWORD, forgetUser);
  yield takeEvery(OTP_FORGET_PASSWORD, forgetUserWithOtp);
  yield takeEvery(STAFF_FORGET_PASSWORD, forgetStaff);
  yield takeEvery(STAFF_OTP_FORGET_PASSWORD, forgetStaffWithOtp);
}

function* forgetPasswordSaga() {
  yield all([fork(watchUserPasswordForget)]);
}

export default forgetPasswordSaga;
